import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { userInfoLinkedBusinessAccountsCacheKey } from "./constants";
import type { UserInfoLinkedBusinessAccountsResponse } from "./types";

export const getUserInfoLinkedBusinessAccountsByIdentifier = reactQueryFetcherAdapter(
  userInfoLinkedBusinessAccountsCacheKey,
  async (signal, userIdentifier: string): Promise<UserInfoLinkedBusinessAccountsResponse> => {
    return fetch<UserInfoLinkedBusinessAccountsResponse>(
      `/apps/user_info_linked_business_accounts/${encodeURIComponent(userIdentifier)}`,
      "GET",
      {},
      { signal }
    );
  }
);
